export enum VoiceConstants {
	minimumMeaningfulSilenceThreshold = 1000,
	defaultMeaningfulSilenceThresholdInSeconds = 2
}
